module.exports = angular
  .module("directives.framecontent", [])
  .directive("framecontent", function ($compile, $parse) {

    return {
      restrict: "A",
      link: function (scope, element, attrs) {
        
        var model = $parse(attrs.framecontent);
        scope.$watch(model, function (newcontent) {
          if (newcontent) {
            scope.contenthtml = newcontent;
            var iframe = element[0];
            iframe.contentWindow.document.write(newcontent);
          }
        });
      }
    };
  });
